<template>
  <div>
    <b-navbar
      class="fixed-top"
      type="dark"
      variant="dark">
      <ul class="navbar-nav d-md-none">
        <li
          class="nav-item position-relative"
          @click="openChat">
          <message-icon
            :size="20"
          />
          <b-badge
            v-if="$parent.$refs.sideBar && $parent.$refs.sideBar.$refs.sideChat.totalChat > 0 "
            variant="danger">{{ $parent.$refs.sideBar.$refs.sideChat.totalChat }}
          </b-badge>
        </li>
        <li
          class="nav-item position-relative"
          @click="openParticipants">
          <account-multiple-icon
            :size="20"
            fill-color="#bbbbbb"
          />
          <b-badge
            v-if="$parent.numberOfPeople"
            variant="outline"> {{ $parent.numberOfPeople }}
          </b-badge>
        </li>
      </ul>
      <b-navbar-brand class="mx-auto mobilePush">
        <lock-icon
          v-if="Object.keys(meetingInfo).length > 0 && meetingInfo.isLocked"
          :size="18"
          class="infoTrigger"
          fill-color="#F8F8F8"
        />
        <b
          v-if="Object.keys(meetingInfo).length > 0"
          class="meeting-title">
          {{ meetingInfo.title }}
        </b>
        <information-outline-icon
          v-if="Object.keys(meetingInfo).length > 0"
          :size="19"
          class="infoTrigger"
          fill-color="#BBBBBB"
          @click="launchInfo()"
        />
      </b-navbar-brand>
    </b-navbar>
    <b-modal
      id="meeting-info"
      ref="meetingInfo"
      :hide-header="true"
      :cancel-disabled="true"
      content-class="info"
      ok-title="Done"
      button-size="sm"
      ok-variant="primary"
    >
      <b-container
        fluid
        class="p-0">
        <span
          class="closeInfo"
          @click="$refs.meetingInfo.hide()"><window-close-icon/></span>

        <b-row no-gutters>
          <b-col sm="auto">
            <b-row no-gutters>
              <b-col>
                <h4>{{ meetingInfo.title }}
                  <small
                    v-if="meetingInfo.start"
                    class="d-block">
                    <span v-show="isPM(meetingInfo.start) === isPM(meetingInfo.end)">
                      {{ meetingInfo.start | moment('dddd, MMMM D &nbsp;•&nbsp;  h:mm') }}
                    </span>
                    <span v-show="isPM(meetingInfo.start) !== isPM(meetingInfo.end)">
                      {{ meetingInfo.start | moment(' dddd, MMMM D &nbsp;•&nbsp; h:mma') }}
                    </span>
                  - {{ meetingInfo.end | moment('h:mma') }}</small>
                </h4>
              </b-col>
            </b-row>
            <hr>
            <b-row class="details">
              <b-col sm="12">
                <video-conference-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"/>
                {{ $t('MEETING.MEETING_ID') }}
                <span class="detail copymtg">{{ meetingInfo.vibeID }}</span>
                <copy-content-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"
                  @click="copyMeetingId()"/>
              </b-col>
              <b-col sm="6">
                <lock-outline-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"/>
                {{ $t('MEETING.MEETING_MODKEY') }} <div class="detail modkey">****</div>
              </b-col>
              <b-col sm="6">
                {{ $t('MEETING.MEETING_ACCESSKEY') }} <div class="detail pin">{{ meetingInfo.accessPin }}</div>
              </b-col>
            </b-row>
            <hr>
            <b-row class="smallDetails">
              <b-col class="col-4">
                <information-outline-icon
                  :size="19"
                  class="float-left"/>
                {{ $t('MEETING.MEETING_COMMUNITY') }} <b>{{ meetingInfo.community }}</b>
              </b-col>
              <b-col class="col-4">
                {{ $t('MEETING.MEETING_BOOKED_BY') }}<b>{{ meetingInfo.ownerFName }} {{ meetingInfo.ownerLName }}</b>
              </b-col>
              <b-col class="col-4">
                {{ $t('MEETING.MEETING_TYPE') }}<b v-show="meetingInfo.type === 0">{{ $t('MEETING.MEETING_OPEN_MEETING') }}</b>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer="{ close}">
        <b-dropdown
          id="copy"
          :text="updateInviteDropbox()"
          :disabled="!('text' in $parent.meetingInvText)"
          split
          variant="grey"
          @click="copy(copied ? copied : 'Invitation' )">
          <b-dropdown-item
            v-if="copied && copied != 'Invitation'"
            @click="copy('Invitation')"><span>{{ $t('MEETING.COPY_INVITE') }}</span></b-dropdown-item>
          <b-dropdown-item
            v-if="copied != 'App Link'"
            @click="copy('App Link')"><span>{{ $t('MEETING.COPY_APPLINK') }}</span></b-dropdown-item>
          <b-dropdown-item
            v-if="copied != 'Web Link'"
            @click="copy('Web Link')"><span>{{ $t('MEETING.COPY_WEBLINK') }}</span></b-dropdown-item>
        </b-dropdown>
        <button
          type="button"
          class="btn btn-primary btn-sm ms-auto"
          @click="close()">{{ $t('MEETING.MEETING_DONE') }}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DialpadIcon from "icons/Dialpad"
import PhoneIcon from "icons/Phone"
import VideoConferenceIcon from "../icons/VideoConference";
import CopyContentIcon from "../icons/CopyContent";
import MenuIcon from "icons/Menu"
import InformationOutlineIcon from "icons/InformationOutline"
import MessageIcon from "icons/Message"
import LockIcon from "icons/Lock"
import LockOutlineIcon from "icons/LockOutline"
import WindowCloseIcon from "icons/WindowClose"
import AccountMultipleIcon from "icons/AccountMultiple"
import {ref} from "@vue/composition-api";
import { gaEvent } from "../functions/gtag";

export default {
  name: 'NavBar',
  components: {
    MenuIcon,
    PhoneIcon,
    DialpadIcon,
    AccountMultipleIcon,
    MessageIcon,
    LockIcon,
    LockOutlineIcon,
    InformationOutlineIcon,
    VideoConferenceIcon,
    CopyContentIcon,
    WindowCloseIcon
  },
  props: {
    meetingInfo: {
      type: Object,
      default: () => {
      }
    },
  },
  setup(props, context) {
    const copied = ref(false)

    function openChat() {
      context.parent.expanded = !context.parent.expanded
      context.parent.$refs.sideBar.chat = !context.parent.$refs.sideBar.chat
    }

    function launchInfo(){
      gaEvent({'ACTION': 'action', 'video_info': ''});
      context.parent.askMeetingInvText()
      this.$bvModal.show('meeting-info')
    }

    function openParticipants() {
      context.parent.expanded = !context.parent.expanded
      context.parent.$refs.sideBar.participant = !context.parent.$refs.sideBar.participant
    }

    function copyMeetingId() {
      navigator.clipboard.writeText(props.meetingInfo.vibeID)
    }

    function copy(type){
      if (!navigator.clipboard) {
        var copyElement = document.createElement('textarea')
        if (Object.keys(context.parent.meetingInvText).length > 0) {
          const splitInvite = context.parent.meetingInvText.text.split('https')
          if (type == 'Invitation')
            copyElement.appendChild(document.createTextNode(context.parent.meetingInvText.text))
          else if (type == 'App Link') {
            splitInvite.length > 1 ? copyElement.appendChild(document.createTextNode('https' + splitInvite[1].substring(0,splitInvite[1].indexOf('\n')))) : ''
          }
          else if (type == 'Web Link')
            splitInvite.length > 2 ? copyElement.appendChild(document.createTextNode('https' + splitInvite[2].substring(0,splitInvite[2].indexOf('\n')))) : ''
        } else {
          copyElement.appendChild(document.createTextNode('NO INFO YET'))
        }
        copyElement.id = 'tempCopyToClipboard'
        document.body.append(copyElement)

        // select the text
        var range = document.createRange()
        range.selectNode(copyElement)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)

        // copy & cleanup
        document.execCommand('copy')
        window.getSelection().removeAllRanges()
        copyElement.remove()
      } else {
        let text = ''
        if (Object.keys(context.parent.meetingInvText).length > 0) {
          const splitInvite = context.parent.meetingInvText.text.split('https')
          if (type == 'Invitation')
            text = context.parent.meetingInvText.text
          else if (type == 'App Link') {
            text = splitInvite.length > 1 ? 'https' + splitInvite[1].substring(0,splitInvite[1].indexOf('\n')) : ''
          }
          else if (type == 'Web Link')
            text = splitInvite.length > 2 ? 'https' + splitInvite[2].substring(0,splitInvite[2].indexOf('\n')) : ''
        } else {
          text = 'NO INFO YET'
        }
        navigator.clipboard.writeText(text)
      }
      copied.value = type
    }
    function isPM(date){
      if (typeof date === 'undefined'){
        return false;
      }
      return this.$moment(date).format('A') === 'PM';
    }

    function updateInviteDropbox(){
      if (copied.value) {
        if (copied.value == 'App Link')
          return context.root.$t('MEETING.COPY_APPLINK_DONE')
        else if (copied.value == 'Web Link')
          return context.root.$t('MEETING.COPY_WEBLINK_DONE')
        else
          return context.root.$t('MEETING.COPY_INVITE_DONE')
      } else {
        return context.root.$t('MEETING.COPY_INVITE')
      }
    }

    return {openChat, openParticipants, launchInfo, isPM, updateInviteDropbox, copy, copyMeetingId, copied}
  }
}
</script>
<style scoped>
.nav-item {
  width: 40px
}
.navbar {
  font-size: 24px;
  border-bottom: 1px solid #000000;
  z-index: 10;
  height: 44px
}

.meeting-title {
  font-size: 16px;
}

.badge {
  position: absolute;
  padding: 2px 5px 4px 5px;
  right: 10px;
  color: #bbbbbb;
  top: 0
}

@media (min-width: 768px) {
  .navbar {
    z-index: 1030
  }
}
</style>
<style>
.info{
 background-color: #ffffff;
  color:#6E6E6E;
}

.info .modal-header .close{
  color:#6E6E6E;
}
.info h4{
  color: #282828;
}
.info .b-dropdown button + button{
  border-left:1px solid #BBBBBB;
  margin-left:0!important;
}
.info h4 small{ color:#6E6E6E; font-weight: 600; font-size:14px }
.info .closeInfo{position: absolute; right: 12px; top: 12px; cursor: pointer; font-size: 27px;color: #6E6E6E;line-height: 1; z-index: 10}
.info .details{ font-weight: 600; font-size: 12px; color: #6E6E6E}
.info .details > div{ line-height:45px;}
.info .details .detail a, .info .details .detail{ font-size: 16px; font-weight: 400; padding-left: 10px; color: #282828; line-height:30px}
.info .details .icon{ padding-right: 10px; vertical-align: text-bottom}
.info .details .numbers{ vertical-align: top; display: inline-block}
.info .smallDetails{ font-size: 12px;}
.info .smallDetails .float-left { padding-right: 12px;}
.info .smallDetails b{ color:#282828; display: block}
.info .btn-secondary { display: none}
.info .modal-footer { border-color:rgba(0,0,0,0.1); justify-content: space-between;}
.info .detail.modkey { margin-top: -0.6em; padding: 0 0 0 2rem; font-size: 17px}
.info .detail.pin { margin-top: -0.75rem; padding: 0; }
.info .copymtg { margin-right: 5px; }
.infoTrigger{
  top: -1px;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .mobilePush{
    position: relative;
    left: -50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue